<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">components</p>
        <h1 class="dg-header">Toggle</h1>
        <vue-markdown :source="docs.docs"></vue-markdown>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        
        <div class="row">
          <div class="col mb-4">
            <p class="h3 dg-subheader">Example</p>
            <ComponentExample>
              <template slot="ui-example">
                <div v-html="docs.usage.componentExample" />
              </template>
              <template slot="code-example">
{{docs.usage.componentExample}}
              </template>
              <template slot="link">
                <a href="https://codepen.io/emichigan/pen/WLwrYK" class="edit-link btn btn-primary btn-sm" target="_blank">Edit on Codepen</a>
              </template>
            </ComponentExample>
          </div>
        </div>

        <ComponentDoc :docs="docs"></ComponentDoc>
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
import VueMarkdown from 'vue-markdown';
import ComponentExample from "../ComponentExample";
import ComponentDoc from "../ComponentDoc";
import Docs from '../../../static/docs.json';

export default {
  name: "Tabs",
  components: {
    VueMarkdown,
    ComponentExample,
    ComponentDoc
  },
  data: function() {
    return {
      docs: Docs.components.find(component => component.tag === 'som-toggle')
    }
  },
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">

</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Toggle.vue